// The customer line's labels are all this wide, so its own width says how many fit.
export const LABEL_WIDTH = 200;
export const GAP = 16;
const ELLIPSIS_WIDTH = 16;

/** All labels if they fit, else as many as leave room for a «…» — never fewer than one. */
export const fittingCount = (width: number, total: number) => {
  if (total * LABEL_WIDTH + (total - 1) * GAP <= width) return total;
  return Math.max(1, Math.floor((width - ELLIPSIS_WIDTH) / (LABEL_WIDTH + GAP)));
};
